import React from 'react'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import { Modal, Spin, Icon} from "antd";
import {getWithdrawDetails} from "../../../actions/WithdrawAction";
import {Utils} from "../../../services/Utlis";

class WithdrawDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        }
    }

    /*componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.withdraw.details.length && this.props.withdraw.details.length) {
            this.setState({
                checkedList: this.props.affiliates.permissions,
            });
        }
    }*/

    showDetailsModal = () => {
        this.props.dispatch(getWithdrawDetails(this.props.id)).then(
             this.setState({
                visible: true,
            }),
        )
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };


    render() {
        const antIcon = <Icon type="loading" className="ta--ant_loader" spin/>;

        let detailsContent = () => {
            
            if(this.props.withdraw.details) {
                return (
                    <div className="ta--pb-12">
                        <span className="ta--txt-mid-dark">{this.props.intl.messages.amount}</span>
                        <p className="ta--fw-b ta--txt-dark ta--mb-16">{Utils.numberWithCommas(this.props.withdrawAmount)}</p>

                        <span className="ta--txt-mid-dark">{this.props.intl.messages.bank_name}</span>
                        <p className="ta--fw-b ta--txt-dark ta--mb-16">{this.props.withdraw.details.BankName}</p>

                        <span className="ta--txt-mid-dark">{this.props.intl.messages.sheba_number}</span>
                        <p className="ta--fw-b ta--txt-dark ta--mb-16">{this.props.withdraw.details.ShebaNumber}</p>

                        <span className="ta--txt-mid-dark">{this.props.intl.messages.account_number}</span>
                        <p className="ta--fw-b ta--txt-dark ta--mb-16">{this.props.withdraw.details.AccountNumber}</p>

                        <span className="ta--txt-mid-dark">{this.props.intl.messages.card_number}</span>
                        <p className="ta--fw-b ta--txt-dark ta--mb-16">{this.props.withdraw.details.CardNumber}</p>

                        <span className="ta--txt-mid-dark">{this.props.intl.messages.name}</span>
                        <p className="ta--fw-b ta--txt-dark ta--mb-16">{this.props.withdraw.details.Name}</p>
                    </div>
                )
            }
        };
        
        let view = this.props.type === 1 ? <i onClick={this.showDetailsModal} className='view-icon ta--f-20 ta--mh-12'></i> : '';
 
        return (
            <React.Fragment>
                    {view}

                    <Modal
                        title={this.props.intl.messages.withdraw_details}
                        visible={this.state.visible}
                        centered
                        onCancel={this.handleCancel}
                        footer={false}
                    >
                        <Spin indicator={antIcon} spinning={this.props.withdraw.details.inProcess}>
                            {detailsContent()}
                        </Spin>
                    </Modal>

            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        withdraw: state.withdraw
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(WithdrawDetails));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Withdraw/WithdrawDetails.js